<script setup>
    import { reactive, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import { updatePassword, EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";
    import HeaderComponent from '../../components/common/HeaderComponent.vue'
    import NavigationBar from '../../components/business/NavigationBar.vue'
    import DefaultModalComponent from '../../components/common/DefaultModalComponent.vue'
    import Firebase from "../../firebase_settings/index.js"
    import utilFunctions from "../../firebase_settings/utils.js"
    import Error from "../../firebase_settings/error.js"

    const auth = Firebase.auth
    const route = useRoute()
    //パスワードの値を保持するリアクティブオブジェクト
    const reactiveObj = reactive({
        //現在の管理パスワード
        password: "",
        //新しい管理パスワード
        newPassword1: "",
        //新しい管理パスワード（確認）
        newPassword2: "",
    })
    //モーダルウィンドウ関連の値を保持するリアクティブオブジェクト
    const reactiveModalObj = reactive({
        //モーダル開閉
        modalFlag: false,
        //モーダルに表示するメッセージ
        modalMessage: "",
        //モーダルの再描画用のキー
        modalRenderkey: 0,
        //企業コード
        corporateId: ''
    })
    //全ての入力フォームが入力されたときに変更ボタンを活性化させる
    const inputSomeData = () => {
        //変更ボタンの活性化フラグ
        let equalFlag = false
        //全ての入力フォームが入力されたときに変更ボタンの活性化フラグをTrueにする
        if(reactiveObj.password && reactiveObj.newPassword1 && reactiveObj.newPassword2) {
                equalFlag = true
        }
        //活性判定フラグTrueなら変更ボタンを活性化そうでないなら非活性化
        equalFlag? document.getElementById('commonButton').disabled = false: document.getElementById('commonButton').disabled = true
    }
    //モーダルウィンドウを表示する際に実行する
    const showDefaultModal = () => {
        //新しいパスワードの1回目と2回目が同じ値であること
        if(reactiveObj.newPassword1 === reactiveObj.newPassword2){
            reactiveModalObj.modalFlag= true
            reactiveModalObj.modalMessage = `入力した内容で管理パスワードを変更します。<br><br>よろしいですか？`
            //モーダルウィンドウのメッセージ更新するためを再描画させる
            reactiveModalObj.modalRenderkey++
        }
        //新しいパスワードの1回目と2回目が異なる値のとき
        else {
            alert(Error.errorResult({code: 'APE0002'}, route.name))
        }
    }
    //モーダルウィンドウを閉じる際に実行
    const closeDefaultModal = (editFlag) => {
        //モーダルウィンドウを閉じる
        reactiveModalObj.modalFlag= false
        //変更ボタンを押下した時
        if(editFlag) {
            //現在の利用者情報を取得
            const user = auth.currentUser;
            const credential = EmailAuthProvider.credential(
                user?.email ?? '',
                reactiveObj.password
            )
            //再度auth認証でサインインを行う
            reauthenticateWithCredential(user, credential)
            // サインイン成功時
            .then(() => {
                const newPassword = reactiveObj.newPassword1
                updatePassword(user, newPassword)
                .then(() => {
                    alert('パスワードの更新が完了いたしました')
                    reactiveObj.password = ""
                    reactiveObj.newPassword1 = ""
                    reactiveObj.newPassword2 = ""
                })
                .catch((error) => {
                    alert(Error.errorResult(error, route.name))
                });
            })
            // サインイン失敗時
            .catch((error) => {
                alert(Error.errorResult(error, route.name))
            });
        }
    }
    onMounted(async () => {
        reactiveModalObj.corporateId = await utilFunctions.getCorporateId()
    })
    //リアクティブオブジェクトの監視
    watch(reactiveObj, () => {
        inputSomeData()
    })
</script>

<template>
    <HeaderComponent></HeaderComponent>
    <NavigationBar></NavigationBar>
    <main>
        <link rel="stylesheet" href="./togglePassword.css">
        <link href="https://use.fontawesome.com/releases/v5.6.1/css/all.css" rel="stylesheet">
        <div class="adminPassword">
            <div class="titleArea">
                <p class="title">管理パスワード</p>
            </div>
            <table class="commonTable">
                <tbody>
                    <tr>
                        <th></th>
                    </tr>
                    <tr>
                        <td class="firstTd notButtom">　現在の管理パスワード</td>
                    </tr>
                    <tr>
                        <td class="firstTd notTop">
                            <input type="checkbox" class="checkPassword">
                            <div class="togglePassword">
                                <input type="password" class="hideText" v-model="reactiveObj.password">
                                <!--<input type="text" class="showText" v-model="reactiveObj.password">-->
                                <!--<label for="checkPassword" class="fa fa-eye"></label>-->
                                <!--<label for="checkPassword" class="fa fa-eye-slash"></label>-->
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="firstTd notButtom">　新しい管理パスワード</td>
                    </tr>
                    <tr>
                        <td class="firstTd notTop">
                            <input type="checkbox" class="checkPassword">
                            <div class="togglePassword">
                                <input type="password" class="hideText" v-model="reactiveObj.newPassword1">
                                <!--<input type="text" class="showText" v-model="reactiveObj.password">-->
                                <!--<label for="checkPassword" class="fa fa-eye"></label>-->
                                <!--<label for="checkPassword" class="fa fa-eye-slash"></label>-->
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="firstTd notButtom">　新しい管理パスワード（確認）</td>
                    </tr>
                    <tr>
                        <td class="firstTd notTop">
                            <input type="checkbox" class="checkPassword">
                            <div class="togglePassword">
                                <input type="password" class="hideText" v-model="reactiveObj.newPassword2">
                                <!--<input type="text" class="showText" v-model="reactiveObj.password">-->
                                <!--<label for="checkPassword" class="fa fa-eye"></label>-->
                                <!--<label for="checkPassword" class="fa fa-eye-slash"></label>-->
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="updateArea notButtom"><button type="button" id="commonButton" @click="showDefaultModal()" disabled>変更する</button></td>
                    </tr>
                    <tr>
                        <td class="notTop"><router-link :to="{name: 'userpasswordreset', query: {CorporateId: reactiveModalObj.corporateId}}">パスワードを忘れた方はこちら</router-link></td>
                    </tr>
                </tbody>
            </table>
            <DefaultModalComponent :key="reactiveModalObj.modalRenderkey" :modalMessage="reactiveModalObj.modalMessage" v-show="reactiveModalObj.modalFlag" @executeMethod="closeDefaultModal"></DefaultModalComponent>
        </div>
    </main>
</template>

<style scoped>
    .adminPassword{
        padding: 0 5% 0 25%;
        background-color: #e7e6e6;
    }
    .commonTable td {
        height: 75px;
    }
    .commonTable .updateArea {
        height: 150px;
    }
    .commonTable tr:first-child>*:last-child{
        border-radius: 20px 20px 0 0;
    }
    #commonButton {
        width: 25%;
        height: 50%;
        top: 25%;
        left: 12.5%;
    }
    @media (max-width: 1150px) {
        .adminPassword{
            padding: 0 5% 0 5%;
        }
        #commonButton {
            left: 25%;
            width: 50%;
        }
    }
</style>
